import { Typography } from 'antd';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
const { Text } = Typography;
type Props = {
  createdDate?: Date;
};
export default function TopicLastMessageTime({ createdDate }: Props) {
  const [time, setTime] = useState<string>();

  useEffect(() => {
    let interval = setInterval(() => {
      setTime(dayjs(new Date(createdDate || new Date())).fromNow(true));
    }, 1000);
    return () => clearInterval(interval);
  }, [createdDate]);

  return (
    <Text type='secondary' className='lastest-message-datetime'>
      {time}
    </Text>
  );
}
